import { post, get } from "../../libs/ajax.js"
// 工单看板
export default {
  // 看板筛选条件接口
  getWorkOrderSearchConfig: (data, options) => {
    return get("/work_order/search_config", data, options)
  },
  // 制作人 / 制作部门 下拉接口
  getWorkOrderSearchList: (data, options) => {
    return post("/work_order/dashboard/get_search_list", data, options)
  },
  // 看板数量
  getWorkOrderDataNum: (data, options) => {
    return post("/work_order/dashboard/get_data_num", data, options)
  },
  // 工单速览
  getWorkOrderQuickOverview: (data, options) => {
    return post("/work_order/dashboard/get_quick_overview", data, options)
  },
  // 需求状态分布
  getDemandStatus: (data, options) => {
    return post("/work_order/dashboard/get_demand_status", data, options)
  },
  // 需求完成情况
  getDemandCompletion: (data, options) => {
    return post("/work_order/dashboard/get_demand_completion", data, options)
  },
  // 需求分析
  getRequirementAnalysis: (data, options) => {
    return post("/work_order/dashboard/get_requirement", data, options)
  },
  // 插单看板（workOrder_v5 §10）：公共查询项 + lead_days(''=全部/0/1/2)。节点 work_order_rush_board
  getRushBoard: (data, options) => {
    return post("/work_order/dashboard/get_rush_board", data, options)
  },
  // 产能分析
  getCapacityAnalysis: (data, options) => {
    return post("/work_order/dashboard/get_capacity", data, options)
  },
}
